var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"information"},[_c('van-nav-bar',{staticClass:"main-nav",attrs:{"title":_vm.title,"left-arrow":""},on:{"click-left":_vm.onClickLeft}}),_c('div',{staticClass:"content"},[_c(_vm.curCompon,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }